import styled from 'styled-components';
import { Close as CloseIcon } from '@mui/icons-material';
import { Edit as EditIcon } from '@mui/icons-material';
import { ContainerSection } from '../styles';


export const Container = styled.div`
  background-color: ${({ theme }) => theme.pantone656C};
  padding: 1rem;
  border-radius: 6px;
  margin: 0;
`;

export const ContainerScroll = styled(ContainerSection)`
  max-height: 390px;
  overflow-y: auto;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

export const HeaderText = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  margin-right: 1rem;
`;

export const IconClose = styled(CloseIcon)`
  &&& {
    cursor: pointer;
  }
`;

export const IconEdit = styled(EditIcon)`
  &&& {
    cursor: pointer;
  }
`;
